import Service from "../../Services";

const User = {
  namespaced: true,
  state: {
    form: {
      id : '',
      firstname : '',
      lastname : '',
      username : '',
      password : '',
      c_password : '',
      status : '',
      profile_image : '',
      profile_image_show : '',
      user_role_id : '',
      email : '',
    }
  },
  mutations: {
    GET_FORM: (state, res) => {
      state.form = res;
    },
    CLEAR_FORM_DATA: state => {
      state.form = {
        id : '',
        firstname : '',
        lastname : '',
        username : '',
        password : '',
        c_password : '',
        status : '',
        profile_image : '',
        profile_image_show : '',
        user_role_id : '',
        email : '',
      };
    },
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    getUser({ commit }, {page,search,sort_date}) {
      return Service.UserAPI.getUser(page,search,sort_date);
    },
    // eslint-disable-next-line no-unused-vars
    showUser({ commit }, id) {
      return Service.UserAPI.showUser(id);
    },
    // eslint-disable-next-line no-unused-vars
    saveUser({ commit }, { id, data }) {
      if (id) {
        return Service.UserAPI.updateUser(id, data);
      } else {
        return Service.UserAPI.createUser(data);
      }
    },
    // eslint-disable-next-line no-unused-vars
    deleteUser({ commit }, id) {
      return Service.UserAPI.deleteUser(id);
    },
    setFormUser({ commit }, res) {
      commit("GET_FORM", res);
    },
    clearFormData({ commit }) {
      commit("CLEAR_FORM_DATA");
    },
  }
};
export default User;
